<script setup lang="ts">
import { computed } from "vue";

import StickerSelector from "@/components/StickerSelector/StickerSelector.vue";
import MenuListFooter from "@/components/ui/MenuList/MenuListFooter.vue";
import { useSearchMenuStore } from "@/store/search/searchMenu";

import StickersItemTooltip from "../tooltips/StickersItemTooltip.vue";
import SearchDropdown from "./SearchDropdown.vue";

const store = useSearchMenuStore();
const anySelected = computed(() => store.selectedFlagStrings.size > 0);
</script>

<template>
  <SearchDropdown
    name="stickers"
    icon="general/sticker"
    label-key="general.stickers"
    :selected="anySelected"
  >
    <template #tooltip>
      <StickersItemTooltip :stickers="store.flags" />
    </template>
    <StickerSelector v-autofocus multiselect :selected="store.flags" @select="store.toggleFlag" />
    <MenuListFooter :disabled="!anySelected" @click="store.clearFlags" />
  </SearchDropdown>
</template>
